import { createPostEndpoint } from '@sonar-software/sonar-http';
import { InitiativeLink } from '@types';

export type PostInitiativeLinkRequest = {
	initiativeId: number;
	title: string;
	url: string;
};

export const postInitiativeLink = createPostEndpoint<PostInitiativeLinkRequest, InitiativeLink>(
	({ initiativeId }) => `/api/v3/initiatives/${initiativeId}/links`
);
